<template>
  <div>
    <div class="mb-3">
      <label for="">{{ 'Header' | translate }}</label>
      <input
        class="form-control"
        type="text"
        v-model="block.header"
        :placeholder="$t('Header')"
        maxlength="200"
      />
    </div>

    <hr />

    <MarkdownEditor @change="change" :value="block.html"></MarkdownEditor>
  </div>
</template>

<script>
import MarkdownEditor from './../MarkdownEditor'

export default {
  components: {
    MarkdownEditor,
  },
  props: ['block'],
  methods: {
    change(html) {
      this.$set(this.block, 'html', html)
    },
  },
}
</script>
<style></style>
